import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class FormItemCard extends Vue {

  @Prop() itemTitle: any;
  // @Prop() isRequired: boolean = false;

}